var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileTrayFull = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.679 9.738H3.321a.592.592 0 0 0-.592.592v9.468c0 .327.265.592.592.592h17.358a.592.592 0 0 0 .592-.592V10.33a.592.592 0 0 0-.592-.592Zm-.592 1.183v8.285H3.913V10.92h16.174Zm-4.142 1.973-.106.01a.592.592 0 0 0-.486.582v.986H8.645v-.986l-.009-.106a.592.592 0 0 0-1.174.106v1.578l.01.107a.59.59 0 0 0 .582.485h7.89l.106-.01a.592.592 0 0 0 .486-.582v-1.578l-.01-.106a.592.592 0 0 0-.582-.486Zm2.367-6.417a.592.592 0 0 1 .106 1.174l-.106.01H6.477a.592.592 0 0 1-.106-1.175l.106-.01h11.835ZM15.156 3.61a.592.592 0 0 1 .106 1.174l-.106.01H9.633a.592.592 0 0 1-.106-1.175l.106-.01h5.523Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileTrayFull);
export default ForwardRef;